exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hero-unit-video {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n  background: #111;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden; }\n  .hero-unit-video:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: rgba(17, 17, 17, 0.76);\n    z-index: 91; }\n  .hero-unit-video > div {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0; }\n  .hero-unit-video video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    opacity: 0; }\n    .hero-unit-video video.loaded {\n      opacity: 1; }\n  .hero-unit-video .progress-video-bar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    height: 2px;\n    z-index: 99;\n    background: rgba(255, 255, 255, 0.5);\n    transform-origin: 0 0 0;\n    transform: scaleX(0); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/hero-unit/hero-unit-video/hero-unit-video.scss
// module id = 599
// module chunks = 0